import { Component, EventEmitter, Output } from '@angular/core';
import { CreateOrUpdateOrderItem } from '@interfaces';
import { BusinessUnitId } from '@enums';

@Component({
  selector: 'unicon-add-product-multi-category',
  standalone: false,
  templateUrl: './add-product-multi-category.component.html',
  styleUrl: './add-product-multi-category.component.scss',
})
export class AddProductMultiCategoryComponent {
  @Output() result = new EventEmitter<CreateOrUpdateOrderItem>();
  @Output() cancel = new EventEmitter<void>();

  public readonly CONCRETE_ID = BusinessUnitId.CONCRETE;
  public readonly JOISTS_ID = BusinessUnitId.JOISTS;
  public readonly BAGGED_ID = BusinessUnitId.BAGGED;

  public onProductAdded(orderItem: CreateOrUpdateOrderItem): void {
    this.result.emit(orderItem);
  }

  public onCancelProduct(): void {
    this.cancel.emit();
  }
}
